(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/collections/tickets.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/collections/tickets.js');

'use strict';

svs.numbergames.game_model.collections.Tickets = Backbone.Collection.extend({
  model: svs.numbergames.game_model.models.Ticket,
  parse(models, options) {
    if (svs.tur.PauseCheck.isBlocked()) {
      return [];
    }

    models = models.filter(model => model.quantity > 0);
    if (!models.length && options.hasTickets) {
      models.push({});
    }
    const modelsWithQuantity = models.filter(model => model.quantity > 0);
    modelsWithQuantity.forEach(model => {
      model.isDisable = false;
    });
    if (modelsWithQuantity.length) {
      return modelsWithQuantity;
    }
    return models;
  },
  calculatePrice() {
    return this.filter(curr => !curr.get('isDisabled')).reduce((acc, curr) => acc + curr.get('price') * curr.get('quantity'), 0);
  },
  disableTickets(isDisabled) {
    this.forEach(model => model.set('isDisabled', isDisabled));
  },
  selectedTickets() {
    return this.filter(model => !model.get('isDisabled') && model.get('quantity'));
  }
});

 })(window);